import React from "react";
import {Input, Modal} from "antd";
import {observer} from "mobx-react";

const TitleModal = observer(({
  history,
  itemId,
  item,
    dashboard,
  titleModalVisible,
  setTitleModalVisible,
  setAddingToDashboard,
  finalVizState,
  setTitle,
  finalTitle
}) => {
  //const addDashboardItem = dashboard.
  /*
  const [addDashboardItem] = useMutation(CREATE_DASHBOARD_ITEM, {
    refetchQueries: [
      {
        query: GET_DASHBOARD_ITEMS
      }
    ]
  });
  const [updateDashboardItem] = useMutation(UPDATE_DASHBOARD_ITEM, {
    refetchQueries: [
      {
        query: GET_DASHBOARD_ITEMS
      }
    ]
  });*/
  return (
    <Modal
      key="modal"
      title="Сохранить"
      visible={titleModalVisible}
      onOk={async () => {
        setTitleModalVisible(false);
        setAddingToDashboard(true);

        try {
          /*await (itemId ? updateDashboardItem : addDashboardItem)({
            variables: {
              id: itemId,
              input: {
                vizState: JSON.stringify(finalVizState),
                name: finalTitle
              }
            }
          });*/
          dashboard.setItem(itemId, {vizState: JSON.stringify(finalVizState), name: finalTitle});
          dashboard.postToServer();
          history.push(`/wd/${dashboard.id}`);
        } finally {
          setAddingToDashboard(false);
        }
      }}
      onCancel={() => setTitleModalVisible(false)}
    >
      <Input
        placeholder="Название элемента"
        value={finalTitle}
        onChange={e => setTitle(e.target.value)}
      />
    </Modal>
  );
});

export default TitleModal;
